// extracted by mini-css-extract-plugin
module.exports = {"clientContainer":"ClientCarousel_clientContainer__7NVNL","imgClient":"ClientCarousel_imgClient__1zgFp"};